import { grey } from "@mui/material/colors";

const styles = {
  container: {
    position: "relative",
    height: "100%",
    overflowY: "auto",
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
  },
  header: {
    p: 1,
    borderBottom: `1px solid ${grey[200]}`,
  },
  body: (hasBanner: boolean) => ({
    pb: { xs: 10, xl: 4 },
    overflowY: "auto",
    height: {
      xs: "auto",
      md: hasBanner ? "calc(100vh - 260px)" : "calc(100vh - 200px)",
      lg: hasBanner ? "calc(100vh - 220px)" : "calc(100vh - 160px)",
    },
  }),
  buttonTab: {
    textTransform: "none",
    color: grey[700],
    fontSize: 12,
    mb: -1,
    borderRadius: 0,
  },
  active: {
    borderBottom: `2px solid`,
    borderColor: "primary.main",
    color: "primary.main",
  },
  cancelAllButton: {
    color: "error.main",
    fontSize: 12,
    textTransform: "none",
  },
};

export default styles;
